var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProjects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.915 3H1.085a.307.307 0 00-.307.307V5.47c0 .17.137.307.307.307h13.83c.17 0 .307-.138.307-.307V3.307A.307.307 0 0014.915 3zM14.111 5.778v6.666a.556.556 0 01-.555.556H2.444v0a.556.556 0 01-.555-.556v0-6.666M6.333 8.556h3.334",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconProjects;